<div style="flex: auto; padding: 5px;">
    <h3>
        <a ng-click="$ctrl.viewDetails()">{{ $ctrl.item.text }}</a>
    </h3>
    <c-property-list properties="$ctrl.item.properties"></c-property-list>
</div>